import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

// Google's gtag stub so gtag exists before hydration on every app.
const dataLayer: unknown[] = window.dataLayer || [];
window.dataLayer = dataLayer;
function gtag() {
  // eslint-disable-next-line prefer-rest-params -- Google's stub pushes the Arguments object
  dataLayer.push(arguments);
}
window.gtag = gtag;

// Initialize Bugsnag for client-side error tracking
if (process.env.NEXT_PUBLIC_BUGSNAG_KEY) {
  Bugsnag.start({
    appType: 'client',
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY,
    appVersion: process.env.NEXT_PUBLIC_GIT_COMMIT,
    releaseStage: process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE,
    plugins: [new BugsnagPluginReact()]
  });

  // this is still necessary because we have window.Bugsnag.notify calls in the monorepo
  window.Bugsnag = Bugsnag;
}

window.forceDD_RUMError = function () {
  window.DD_RUM?.addError(new Error('forced DD_RUM error'));
};
